/**
 * @file   src\components\SplashScreen.tsx
 * @brief  Splash Screen component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState } from '../utils/thirdpartyComponents'; 
import "../styles/apptemplate.scss";
import Splashlogo from '../assets/images/CarWash-Logo.svg';
import Statusbar from '../assets/images/app-status-bar.svg';

const SplashScreen = (props : any) => {
  const [companySplashLogo, setcompanySplashLogo] = useState((props.companyLogo) ? props.companyLogo : Splashlogo);
  return (
    <div className='appscreen-container position-relative'>
        <div className="status-bar"><img src={Statusbar} alt="Car Wash App"/></div>
        <div className="splash-screen d-flex align-items-center justify-content-center h-100">
            <img src={props.companyLogo ? props.companyLogo : Splashlogo} alt="Car Wash App" className='logo-img'/>
        </div>
    </div>
  );
};
export default SplashScreen;
